import { render, staticRenderFns } from "./UserRoleDialog.vue?vue&type=template&id=330df0cf&scoped=true"
import script from "./UserRoleDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRoleDialog.vue?vue&type=style&index=0&id=330df0cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330df0cf",
  null
  
)

export default component.exports